import request from 'admin-ng/util/request-promise';
import {API_KEYS} from '.';

export const all = params => request(API_KEYS, 'get', params);
export const reset = id => request(`${API_KEYS}${id}/reset`, 'post');
